import React from "react";
import "../styles/whatsapp-button.css";
import {getParameterByName} from "../utils/formatter";

export default function ChatbasePopup(props) {
    const handleWhatsAppClick = () => {
        const businessId = getParameterByName("business");

        // Puedes personalizar estos enlaces con números de WhatsApp específicos
        const whatsappUrl = businessId === "W8fBSZcVw5" 
            ? "https://www.wollyhome.com/candela-de-wolly"
            : "https://www.wollyhome.com/candela-de-wolly";
            
        window.open(whatsappUrl, "_blank", "noopener,noreferrer");
    };

    return (
        <div className="whatsapp-sticky-button" onClick={handleWhatsAppClick}>
            <img
                src={require("../assets/whatsapp.png")}
                alt="WhatsApp" 
                width="60" 
                height="60" 
            />
        </div>
    );
}
